import API from "@app/services/api";
import useUser from "@app/zustand/user";

/**
 * Sign out of MAGE-X — and, after a card login, out of Pro Santé Connect as well.
 *
 * Clearing our cookie does not end the wallet's own session: without the hop to its
 * end-session URL, the next person to click the card button on a shared workstation
 * is handed the session of the one who just left. The API answers that URL only for
 * a session opened with a card. Every sign-out button goes through here, so the hop
 * cannot be forgotten on one of them — which is how « Quitter la démo » once went
 * round the wallet.
 *
 * `afterwards` runs when there is no wallet to leave: each button decides where the
 * reader lands.
 */
export function signOut(afterwards: () => void): void {
  API.post({ path: "/user/logout" }).then(
    (res: { psc_logout_url?: string }) => {
      // Dropped here, for every button: a cached account the API then refuses would read as a
      // session that lapsed, and the login page would say so to someone who just signed out.
      useUser.getState().setUser(null);
      if (res?.psc_logout_url) {
        window.location.href = res.psc_logout_url;
        return;
      }
      afterwards();
    },
  );
}
